var _path, _polygon, _polygon2, _path2, _path3, _rect, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x39_3-discover_x2C__Credit_card"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M434.334,81H77.667C57.424,81,41,97.424,41,117.667v276.665C41,414.576,57.424,431,77.667,431H431    c20.243,0,40-16.424,40-36.668V117.667C471,97.424,454.576,81,434.334,81z",
    style: {
      fill: "#F9F9F9"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.771,228.354c9.243-1.909,14.284-8.097,14.284-17.722c0-21.771-23.146-18.639-40.408-18.639l-0.001,62.639h12.223    v-25.055h1.681l16.958,25.055h14.973L432.771,228.354z M422.457,221.021h-3.589v-19.02h3.742c7.715,0,11.917,3.207,11.917,9.243    C434.527,217.66,430.325,221.021,422.457,221.021z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "363.943,192.07 398.549,192.07 398.549,202.764 376.168,202.764 376.168,216.668 397.784,216.668     397.784,227.208 376.168,227.208 376.168,244.167 398.549,244.167 398.549,254.708 363.943,254.708   "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.465,192.07 328.194,234.236 345.153,192.07 358.521,192.07 331.403,256.389 324.834,256.389 298.097,192.07       "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.764,189.779c18.868,0,34.07,15.277,34.07,34.069c0,18.868-15.279,34.07-34.07,34.07    c-18.868,0-34.069-15.279-34.069-34.07C234.694,204.98,249.974,189.779,268.764,189.779z",
    style: {
      fill: "#FF6F00"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.104,194.438v14.514c-15.353-15.354-35.749-3.589-35.749,14.514c0,19.098,21.006,29.411,35.749,14.667v14.514    c-22.687,10.923-48.354-4.354-48.354-29.181C182.75,199.632,208.035,182.98,231.104,194.438z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.855,245.083c8.708,0,17.111-11.687-2.521-18.638c-11.457-4.202-15.43-8.708-15.43-17.34    c0-17.723,23.374-23.986,37.965-10.922l-6.417,8.248c-7.944-8.86-19.021-4.736-19.021,1.912c0,3.36,2.063,5.269,9.396,7.866    c13.903,5.042,18.028,9.55,18.028,19.555c0,22.536-29.639,28.571-43.236,8.632l7.869-7.562    C146.313,242.257,151.049,245.083,156.855,245.083L156.855,245.083z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 62.638,
    width: 12.223,
    x: 118.66,
    y: 192.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M471,394.332V292.98c-29.646,18.515-201.373,106.348-369.99,138.008h330.455     C451.545,430.739,471,414.421,471,394.332z",
    style: {
      fill: "#FF6F00"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.321,192.07H61.445v62.638h17.875c23.604,0,33.687-17.11,33.687-31.242C113.008,205.056,99.258,192.07,79.321,192.07z     M93.604,239.278c-3.743,3.361-8.861,4.889-16.729,4.889h-3.209v-41.403h3.209c7.868,0,12.757,1.299,16.729,5.041    c4.354,3.821,6.799,9.625,6.799,15.66C100.404,229.5,97.958,235.305,93.604,239.278z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.74778e52c8e8ac9f0e07c77835cefd85.svg";
export { ForwardRef as ReactComponent };